import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJobs = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 2C17.7771 2 19.3737 2.77256 20.4723 4.00013L25 4C26.0544 4 26.9182 4.81588 26.9945 5.85074L27 6V27C27 28.0544 26.1841 28.9182 25.1493 28.9945L25 29H7C5.94564 29 5.08183 28.1841 5.00549 27.1493L5 27V6C5 4.94564 5.81588 4.08183 6.85074 4.00549L7 4L11.5277 4.00013C12.6263 2.77256 14.2229 2 16 2ZM21.6587 6.00032C21.8482 6.53644 21.9636 7.10752 21.9927 7.70128L22 8V9C22 9.51284 21.614 9.93551 21.1166 9.99327L21 10H11C10.4872 10 10.0645 9.61396 10.0067 9.11662L10 9V8C10 7.29885 10.1203 6.62579 10.3413 6.00032L7 6V27H25V6L21.6587 6.00032ZM12.0049 7.80036C12.1089 5.68397 13.8578 4 16 4L16.1996 4.0049L16.4031 4.02006C18.4229 4.22216 20 5.92691 20 8H12L12.0049 7.80036Z"
	})
});
export default SvgJobs;
